import React, { useState } from 'react';
import { Typography, Form, App } from 'antd';
import { db } from '../../firebase-config';
import { collection, addDoc, serverTimestamp, query, where, getDocs } from 'firebase/firestore';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import TestForm from '../TestForm'; // 共通フォームをインポート

const { Title } = Typography;

const CreateTestPage = () => {
  const [form] = Form.useForm();
  const { message } = App.useApp();
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [saving, setSaving] = useState(false);

  const handleCreate = async (values) => {
    setSaving(true);
    try {
      const testsRef = collection(db, "tests");
      const q = query(testsRef, where("testName", "==", values.testName.trim()));
      if (!(await getDocs(q)).empty) {
        message.error("テスト名は既に存在します。");
        return;
      }

      const { availabilityRange, ...rest } = values;
      const dataToSave = {
        ...rest,
        testName: values.testName.trim(),
        startTime: availabilityRange?.[0]?.toDate() || null,
        endTime: availabilityRange?.[1]?.toDate() || null,
        createdBy: currentUser.id,
        createdAt: serverTimestamp(),
      };
      await addDoc(testsRef, dataToSave);
      message.success("テストの作成に成功しました。");
      navigate('/tests');
    } catch (error) {
      message.error("テストの作成中にエラーが発生しました。");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <Title level={2}>新規テスト作成</Title>
      <TestForm form={form} onFinish={handleCreate} saving={saving} />
    </div>
  );
};

export default CreateTestPage;
